module.exports = __webpack_public_path__ + "img/benchmark.2d7a3d9e.png";